import React, { FC } from 'react';

import { ModalFooter, ModalTitle, ModalHeader } from '@epoch-ui/components/Modal/modal';
import { Button } from '@epoch-ui/components/Button';

import { useRSVPControlModalContext } from '../rsvpControlContext';

import { NotificationSettingsSection } from './NotificationSettingsSection';

export const SetUpdateNotificationsModalContent: FC = () => {
  const { sendNotifications, guest, swapGuest, navigation } = useRSVPControlModalContext();
  return (
    <>
      <ModalHeader className="tw-m-0 tw-gap-2">
        <ModalTitle className="tw-mb-0 tw-text-2xl tw-font-medium">
          Send update notifications?
        </ModalTitle>
        <span className="tw-text-primary-grey">
          {swapGuest
            ? `Let ${guest.firstName} and ${swapGuest.firstName} know their RSVP has changed.`
            : `Let ${guest.firstName} know their RSVP has changed.`}
        </span>
      </ModalHeader>
      <NotificationSettingsSection />
      <ModalFooter className="tw-mt-0 tw-flex tw-flex-row tw-justify-end">
        <div className="tw-flex tw-flex-row tw-justify-center tw-gap-4">
          <Button
            size="sm"
            onClick={navigation.onClickBack}
            className="tw-flex-1 tw-rounded-[8px]"
            variant="secondary"
          >
            Back
          </Button>
          <Button
            size="sm"
            loading={navigation.loading}
            className="tw-flex-1 tw-rounded-[8px]"
            variant="primary"
            onClick={navigation.onClickSubmit}
          >
            {sendNotifications ? 'Send' : `Don't send`}
          </Button>
        </div>
      </ModalFooter>
    </>
  );
};
